import React from 'react'
import { Route } from 'react-router'
import lang from '@/lang'

const FirstStepsView = React.lazy(() => import('./view/firstSteps-view.component'))

const firstStepsRoutes = (
  <>
    <Route path='firstSteps' Component={FirstStepsView} handle={{ title: lang.firstSteps.title }} />
  </>
)

export default firstStepsRoutes
